import { FC, MouseEvent } from "react";
import {
  GridActionsCellItem,
  useGridApiContext,
  GridApi,
} from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { Edit as EditIcon } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { ActionButtonProps } from "./VehiclesTable";

export const EditButton: FC<ActionButtonProps> = ({ rowId }) => {
  const apiRef = useGridApiContext<GridApi>();
  const { t } = useTranslation();
  const label = t("vehicles.edit.tooltip");

  const onClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    apiRef.current.startRowEditMode({ id: rowId });
    apiRef.current.setCellFocus(rowId, "licensePlate");
  };

  return (
    <GridActionsCellItem
      icon={
        <Tooltip title={label}>
          <EditIcon />
        </Tooltip>
      }
      label={label}
      onClick={onClick}
    />
  );
};
